import { getAccessToken } from "@components/Utils/Utils.js";

const DEFAULT_SEPA_TEMPLATE_PATH = "/pdfs/SEPA_hoferdigital.pdf";

const buildSepaTemplateCandidates = () => {
  if (process.env.REACT_APP_SEPA_TEMPLATE_URL) {
    return [process.env.REACT_APP_SEPA_TEMPLATE_URL];
  }

  const candidates = [];
  const accessToken = getAccessToken();

  if (process.env.REACT_APP_SOPHYAPP_API_URL) {
    if (accessToken) {
      candidates.push(
        `${process.env.REACT_APP_SOPHYAPP_API_URL.replace(/\/$/, "")}/de/react/${accessToken}/settings/sepa_template`,
      );
    }
    candidates.push(
      `${process.env.REACT_APP_SOPHYAPP_API_URL.replace(/\/$/, "")}${DEFAULT_SEPA_TEMPLATE_PATH}`,
    );
  }
  if (process.env.REACT_APP_SOPHYAPP_API_URL_LIVE) {
    if (accessToken) {
      candidates.push(
        `${process.env.REACT_APP_SOPHYAPP_API_URL_LIVE.replace(/\/$/, "")}/de/react/${accessToken}/settings/sepa_template`,
      );
    }
    candidates.push(
      `${process.env.REACT_APP_SOPHYAPP_API_URL_LIVE.replace(/\/$/, "")}${DEFAULT_SEPA_TEMPLATE_PATH}`,
    );
  }

  // Keep relative paths as final fallback only (dev server may return index.html with 200).
  candidates.push(DEFAULT_SEPA_TEMPLATE_PATH);

  return [...new Set(candidates)];
};

const hasPdfHeader = (arrayBuffer) => {
  if (!arrayBuffer) return false;
  const bytes = new Uint8Array(arrayBuffer);
  const signature = [0x25, 0x50, 0x44, 0x46, 0x2d]; // %PDF-
  const maxOffset = Math.min(1024, bytes.length - signature.length + 1);
  for (let i = 0; i < maxOffset; i += 1) {
    let matches = true;
    for (let j = 0; j < signature.length; j += 1) {
      if (bytes[i + j] !== signature[j]) {
        matches = false;
        break;
      }
    }
    if (matches) return true;
  }
  return false;
};

export const fetchSepaTemplateBytes = async () => {
  const candidateUrls = buildSepaTemplateCandidates();
  let lastError = null;
  const rejectionReasons = [];

  for (const url of candidateUrls) {
    try {
      const response = await fetch(url, { cache: "no-store" });
      if (!response.ok) {
        rejectionReasons.push(`${url} (status: ${response.status})`);
        continue;
      }

      const bytes = await response.arrayBuffer();
      if (!hasPdfHeader(bytes)) {
        rejectionReasons.push(
          `${url} (status: ${response.status}, content-type: ${response.headers.get("content-type") || "unknown"}, invalid PDF header)`,
        );
        continue;
      }
      return bytes;
    } catch (error) {
      lastError = error;
      rejectionReasons.push(`${url} (${error.message})`);
    }
  }

  if (lastError) {
    throw new Error(
      `SEPA template not reachable or not a valid PDF. Tried: ${rejectionReasons.join("; ")}`,
    );
  }
  throw new Error(
    `SEPA template not reachable or not a valid PDF. Tried: ${rejectionReasons.join("; ")}`,
  );
};
